import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeaturedEditorial from "./components/FeaturedEditorial";
import ChannelStrip from "./components/ChannelStrip";
import RankingList from "./components/RankingList";
import TimelineSection from "./components/TimelineSection";
import RelationSection from "./components/RelationSection";
import ArchiveGrid from "./components/ArchiveGrid";
import DiscussionSection from "./components/DiscussionSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <Hero />
      <main>
        <FeaturedEditorial />
        <ChannelStrip />
        <RankingList />
        <TimelineSection />
        <RelationSection />
        <ArchiveGrid />
        <DiscussionSection />
      </main>
      <Footer />
    </div>
  );
}